module.exports = "/packs/images/accessibility~e46282eb3e8eb42f90e153e4eb7d8569.svg";